import Gleap from 'gleap';

export const trackGleapEvent = (event, data) => {
  try {
    Gleap.trackEvent(event, data || {});
  } catch (_) {
    // Gleap not initialized (anonymous session) or offline — silently ignore
  }
};
